import { useState } from 'react';
import mainStyles from '../../pages/main.module.css';
import styles from './batchPdfDownloadModal.module.css';
import ScreenModal from '../ScreenModal/screenModal';
import Button from '../Button/button';
import Checkbox from '../Checkbox';

export interface BatchPdfDownloadModalProps {
  totalDocumentQuantity: number;
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void
  onSubmit: (shouldIncludePdfFiles: boolean, shouldIncludePreviousVersions: boolean, shouldIncludeAttachmentFiles: boolean) => void
}

function BatchPdfDownloadModal(props: BatchPdfDownloadModalProps) {
  const {
    totalDocumentQuantity,
    onCancel,
    onSubmit,
  } = props;
  const [shouldIncludePdfFiles, setShouldIncludePdfFiles] = useState(false);
  const [shouldIncludePreviousVersions, setShouldIncludePreviousVersions] = useState(false);
  const [shouldIncludeAttachmentFiles, setShouldIncludeAttachmentFiles] = useState(false);

  const handleChangeShouldIncludePdfFiles = (value: boolean) => {
    setShouldIncludePdfFiles(value);
    if (!value) setShouldIncludePreviousVersions(false);
  };

  return (
    <ScreenModal
      customStyles={{
        minWidth: '650px',
        maxHeight: '85%',
        border: 'var(--defaultBorder)',
        display: 'flex',
        flexDirection: 'column',
        color: 'initial',
      }}
    >
      <div className={styles['modal-header']}>
        <div className={styles.title}>
          ファイル一括ダウンロード
        </div>
      </div>
      <div className={styles['modal-body']}>
        <p>ダウンロードするファイルを選択してください。</p>
        <div className={styles.form}>
          <div className={styles.formItem}>
            <Checkbox
              className={mainStyles['text-bold']}
              label="PDFファイル"
              value={shouldIncludePdfFiles}
              onChange={handleChangeShouldIncludePdfFiles}
            />
            <div className={styles.formShift}>
              <Checkbox
                disabled={!shouldIncludePdfFiles}
                label="旧版を含む"
                value={shouldIncludePreviousVersions}
                onChange={setShouldIncludePreviousVersions}
              />
            </div>
          </div>
          <div className={styles.formItem}>
            <Checkbox
              className={mainStyles['text-bold']}
              label="添付ファイル"
              value={shouldIncludeAttachmentFiles}
              onChange={setShouldIncludeAttachmentFiles}
            />
          </div>
        </div>
        <div className={styles.info}>
          <p>
            ※選択中の
            {totalDocumentQuantity}
            件のうち、指定したファイルが存在するもののみが対象です。
          </p>
          <p>※ファイルサイズが大きい場合、ダウンロード用のzipファイルが分割されることがあります。</p>
        </div>
        <div className={styles.alert}>
          <p>ダウンロード準備完了後、メールでダウンロードURLをお知らせします。</p>
          <p className={mainStyles['text-danger']}>※通知メールは他の管理ユーザーにも送信されます。</p>
        </div>
      </div>
      <div className={styles['modal-footer']}>
        <Button size="smaller" color="lighterGray" onClick={onCancel}>キャンセル</Button>
        <Button size="smaller" disabled={!shouldIncludePdfFiles && !shouldIncludeAttachmentFiles && !shouldIncludePreviousVersions} onClick={() => onSubmit(shouldIncludePdfFiles, shouldIncludeAttachmentFiles, shouldIncludePreviousVersions)}>ダウンロード</Button>
      </div>
    </ScreenModal>
  );
}

export default BatchPdfDownloadModal;
